import React from 'react';
import { useSelector } from 'react-redux';
import CountDown from 'components/participates/countDown';

const ItemAlreadyNotify = () => {
  const { detail } = useSelector((state) => state.detail);
  const { startDate, serverDate, initialOffer } = detail;

  return (
    <div className="d-flex flex-column-reverse flex-sm-column pb-15 pb-sm-0">
      <div className="mb-30 mt-30 mt-sm-0 d-none d-sm-block font-weight-bold text-tangaroa">
        Inicia en:
        <CountDown
          closeDate={startDate}
          todayDate={serverDate} />
      </div>
      <div className="bg-alabaster p-0 p-sm-3 py-4 pt-sm-5 text-center">

        <h3 className="text-tangaroa text-left">Oferta inicial:</h3>
        <h3 className="text-tangaroa text-left">{`${initialOffer.toLocaleString()} Puntos Aeroméxico Rewards`}</h3>
        <i className="fas fa-bell my-15 text-tangaroa" />
        <p className="text-tangaroa">
          ¡Notificación activada!
        </p>
        <p className="text-tangaroa">
          Te notificaremos cuando la Subasta Rewards esté disponible para participar.
        </p>
      </div>
    </div>
  );
};

export default ItemAlreadyNotify;
